import BaseRegulation from '../../base_regulation';
import Store from "../../../../../utils/store";

import OntarioResponsibleGamingIconsController
    from "../../../../../components/regulation_components/canada/ontario/responsible_gaming_icons/ontario_responsible_gaming_icons_controller";

export default class CanadaOntarioRegulation extends BaseRegulation {
    static CLASS = 'CanadaOntarioRegulation';

    overrideCurrencySymbol(): string {
        return '$';
    }

    showNetPosition(): boolean {
        return true;
    }

    shouldCallCountryByIP(country:string) {
        return false;
    }

    onStateNotInListClickHandler() {
        this.serviceFactory.windowService().redirect(this.serviceFactory.skinService().getWrongLocationDetectionPath());
    }

    fitToPlayModeEnabled(): boolean {
        return true;
    }

    showAgeResponsibleIconInGame() {
        return false;
    }

    showResponsibleIcons() {
        return true;
    }

    getResponsibleGamingIconsComponent(params){
        return OntarioResponsibleGamingIconsController.create(params);
    }

    stepsBeforeOpenLoginAndRegistration():Promise<void> {
        return new Promise((resolve, reject) => {
            const STATE_POPUP_KEY = 'state-popup'
            if(Store.get(STATE_POPUP_KEY)) {
                return resolve();
            }
            return this.serviceFactory.orbitComponentRenderService().showLocationPopup({
                onStateSelect: ()=> {
                    Store.set(STATE_POPUP_KEY, true);
                    return resolve();
                },
                onStateNotInListClick: ()=> {
                    this.onStateNotInListClickHandler();
                    reject();
                },
                onMessageClosed: ()=> {
                    reject();
                }
            });
        });
    }

    getExternalLinksConfig() {
        return {
            'membership': {
                isCloseBtnAllowed: false
            },
            'upload_document': {
                isCloseBtnAllowed: false
            }
        };
    }
}